





























































































































import { Component, Vue } from 'vue-property-decorator';
import { getTypes, getTypes2, getProducts, assgin, unassgin } from '@/api/assgin';
import { removeFrontZone } from '@/utils/string';
import * as _ from 'lodash';
import SimpleDialog from '@/components/SimpleDialog.vue';
import SearchDialog from '@/components/SearchDialog.vue';
import TypeDialog from '@/components/TypeDialog.vue';
import PoDialog from './components/PoDialog.vue';
import AnomalStockDialog from './components/AnomalStockDialog.vue';
import { getCurrentDate, getCurrentDatetime } from '../../utils/date';

interface IType {
  id: string;
  type_name: string;
  type_no: string;
  not_completed_count: number;
}

interface IType2 {
  id: string;
  type2: string;
}

interface IProduct {
  type: string;
  type2: string;
  item_code: string; // addition filed
  anomaly: any; // addition filed
  item_number: string;
  item_name: string;
  base_unit: string;
  sales_unit: string;
  round: string;
  subtotal: string;
  status: number;
  today_po: string;
  onhand: string;
  item_description: string;
  sotext: string;
  sotext2: string;
}

@Component({
  name: 'Assgin',
  components: { TypeDialog, SimpleDialog, PoDialog, AnomalStockDialog, SearchDialog },
})
export default class extends Vue {
  private types: IType[] = [];

  private types2: IType2[] = [];

  private products: IProduct[] = [];

  private activeTab = 1;

  private search = '';

  private searchDialog = false;

  private selected: Array<string> = [];

  private typesValue: string[] = [];

  private types2Value: string[] = [];

  private roundValue = '';

  private date = '';

  private locationCode = '';

  private hasType2 = false;

  private beginDatetime = '';

  private sortBy: Array<string> = [];

  async created() {
    this.date = getCurrentDate();
    this.locationCode = this.$store.getters['user/locationCode'];
    if (this.$route.params.types === undefined || this.$route.params.round === undefined) {
      this.$router.push({
        name: 'AssginFilter',
      });
    } else {
      this.typesValue = this.$route.params.types.split(',');
      this.roundValue = this.$route.params.round;
      try {
        this.$overlay(true);
        this.types = await getTypes(this.date, this.locationCode);
        this.types2 = await getTypes2(this.date, this.locationCode);
        this.types2.map((type: IType2) => {
          if (type.type2 === '') type.type2 = '空';
          return type;
        });
        await this.getProducts();
      } finally {
        this.$overlay(false);
      }
    }
  }

  private async onTypeChange() {
    try {
      this.$overlay(true);
      await this.getProducts();
    } finally {
      this.$overlay(false);
    }
  }

  private switchTab(tabId: number) {
    this.activeTab = tabId;
    this.selected = [];
    this.search = '';
  }

  private async getProducts() {
    const { data } = await getProducts(
      this.date,
      this.$store.getters['user/locationCode'],
      this.typesValue,
      this.types2ValueByRequest,
      this.roundValue,
    );
    let products = data.list;
    const anomalyStocks = data.anomaly_stocks;
    products = products.map((product: IProduct) => {
      product.item_code = removeFrontZone(product.item_number);
      const anomaly = _.find(anomalyStocks, { item_number: product.item_number });
      product.anomaly = anomaly !== undefined ? anomaly : null;
      return product;
    });
    products = _.sortBy(products, (product: IProduct) => product.item_code);
    if (products.filter((product: IProduct) => product.type2 !== '').length > 0) {
      this.hasType2 = true;
    } else {
      this.hasType2 = false;
    }
    this.products = products;
    this.beginDatetime = getCurrentDatetime();
    if (this.typesValue.includes('107') && this.typesValue.length === 1) {
      this.sortBy = ['sales_unit'];
    } else {
      this.sortBy = [];
    }
  }

  private async assgin() {
    if (this.selected.length === 0) {
      this.$toast('请选择物料', { color: 'red', icon: 'fas fa-info-circle' });
      return;
    }
    this.$overlay(true);
    await assgin(
      this.date,
      this.$store.getters['user/locationCode'],
      this.selected,
      this.beginDatetime,
      getCurrentDatetime(),
    )
      .then(() => {
        this.updateProducts(this.selected, { status: 2 });
        this.selected = [];
        this.$toast('分配成功', { color: 'green', icon: 'fas fa-info-circle' });
      })
      .catch(() => {
        this.$toast('分配失败', { color: 'red', icon: 'fas fa-info-circle' });
      });
    this.$overlay(false);
  }

  private async unassgin() {
    if (this.selected.length === 0) {
      this.$toast('请选择物料', { color: 'red', icon: 'fas fa-info-circle' });
      return;
    }
    this.$overlay(true);
    await unassgin(this.date, this.$store.getters['user/locationCode'], this.selected)
      .then(() => {
        this.updateProducts(this.selected, { status: 0 });
        this.selected = [];
        this.$toast('取消分配成功', { color: 'green', icon: 'fas fa-info-circle' });
      })
      .catch(() => {
        this.$toast('取消分配失败', { color: 'red', icon: 'fas fa-info-circle' });
      });
    this.$overlay(false);
  }

  private backHandle() {
    this.$router.push({ name: 'AssginFilter' });
  }

  private updateProducts(selected: string[], data: object) {
    selected.forEach((item) => {
      this.products.forEach((product: IProduct) => {
        if (product.item_number === item) {
          Object.assign(product, data);
        }
      });
    });
  }

  private showPoDialog(item: any) {
    if (item.today_po > 0) {
      (this.$refs.poDialog as Vue & { open(item: any): () => void }).open(item);
    }
  }

  private showAnomalyStockDialog(item: any) {
    (this.$refs.anomalStockDialog as Vue & { open(item: any): () => void }).open(item);
  }

  private onAnomalyStockSave(item: any) {
    this.products.forEach((product: IProduct) => {
      if (product.item_number === item.item_number) {
        product.anomaly = item.anomaly;
      }
    });
  }

  private onAnomalyStockDestroy(item: any) {
    this.products.forEach((product: IProduct) => {
      if (product.item_number === item.item_number) {
        product.anomaly = null;
      }
    });
  }

  private handleRowClick(product: IProduct) {
    if (this.activeTab === 3 || this.activeTab === 4) return;
    if (this.selected.includes(product.item_number)) {
      const index = this.selected.findIndex((val) => val === product.item_number);
      if (index !== -1) this.selected.splice(index, 1);
    } else {
      this.selected.push(product.item_number);
    }
  }

  private isSelected(product: IProduct) {
    if (this.selected.includes(product.item_number)) {
      return true;
    }
    return false;
  }

  get height() {
    return window.innerHeight - 320;
  }

  get types2ValueByRequest() {
    return this.types2Value.map((type) => {
      if (type === '空') type = '';
      return type;
    });
  }

  get headers() {
    const baseHeader = [
      {
        text: 'Item',
        value: 'item_code',
        sortable: true,
        width: 25,
        align: 'center',
      },
      {
        text: 'Description',
        value: 'item_name',
        sortable: true,
        width: 25,
      },
      {
        text: 'U/M',
        value: 'sales_unit',
        sortable: true,
        width: 25,
        align: 'center',
      },
      {
        text: 'Subtotal',
        value: 'subtotal',
        sortable: true,
        width: 25,
        align: 'center',
      },
    ];

    return baseHeader;
  }

  get pendingProducts() {
    return this.products
      .filter((product: IProduct) => product.status === 0)
      .map((product: IProduct, index: number) => ({
        ...product,
        index: index + 1,
      }));
  }

  get assignedProducts() {
    return this.products
      .filter((product: IProduct) => product.status === 2 || product.status === 3)
      .map((product: IProduct, index: number) => ({
        ...product,
        index: index + 1,
      }));
  }

  get completedProducts() {
    return this.products
      .filter((product: IProduct) => product.status === 1)
      .map((product: IProduct, index: number) => ({
        ...product,
        index: index + 1,
      }));
  }

  get allProducts() {
    return this.products.map((product: IProduct, index: number) => ({
      ...product,
      index: index + 1,
    }));
  }

  get items() {
    switch (this.activeTab) {
      case 1:
        return this.pendingProducts;
      case 2:
        return this.assignedProducts;
      case 3:
        return this.completedProducts;
      case 4:
        return this.allProducts;
      default:
        return [];
    }
  }
}
